import { render, staticRenderFns } from "./NormalSearchNav580.vue?vue&type=template&id=bd24a550&scoped=true&"
import script from "./NormalSearchNav580.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav580.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd24a550",
  null
  
)

export default component.exports